import { render, staticRenderFns } from "./UserInfoBlock.vue?vue&type=template&id=63d273de"
import script from "./UserInfoBlock.vue?vue&type=script&lang=js"
export * from "./UserInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./UserInfoBlock.vue?vue&type=style&index=0&id=63d273de&prod&lang=css"
import style1 from "./UserInfoBlock.vue?vue&type=style&index=1&id=63d273de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports